import { Component, EventEmitter, OnDestroy, OnInit, Output ,Inject, PLATFORM_ID} from '@angular/core';
import { ApiService } from '../../shared/services/apiService.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { CommonService } from '../../shared/services/common.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { FormErrorService } from '../../shared/form-validation/form-error.service';
import { RegexService } from '../../shared/form-validation/regex.service';
import { NgxSpinnerService } from "ngx-spinner";
import { OwlOptions } from 'ngx-owl-carousel-o';
import { environment } from '../../../environments/environment';
import { RootService } from 'src/app/shared/services/root.service';
import { BehaviourSubjectService } from 'src/app/shared/services/behaviour-subject.service';
import { secureStorage } from 'src/app/shared/services/encryption/secureservice';
import { ClevertapService } from 'src/app/shared/services/clevertap/clevertap.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit, OnDestroy {
  environment1 = environment.s3bucket.url;
  @Output() loadParent: EventEmitter<void> = new EventEmitter<void>();
  @Output() loadOtpParent: EventEmitter<void> = new EventEmitter<void>();
  sub: Subscription = new Subscription();
  signupFormGroup: any;
  mobileNo: any;
  banners: any = [];
  isLoading: boolean = false;
  centerBanners: any = [];
  email:any ='';
  stateList: any;

  districtList: any = [];

  loginId: any;
  isTataOk:boolean = false;

  customOptionsForBanner: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 700,
    autoplay: true,
    // nav: true,
    responsiveRefreshRate: 1000000,
    // navText: [
    // "<img class='nav' src='https://d3bslevwxw022c.cloudfront.net/buytrucknbus-dev-home-tatamotors/cv/cv_online/assets/images/crasual-left.svg' alt='crasual-left' />",
    // "<img class='nav' src='https://d3bslevwxw022c.cloudfront.net/buytrucknbus-dev-home-tatamotors/cv/cv_online/assets/images/crasual-right.svg' alt='crasual-left' />"
    // ],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 1
      },
      740: {
        items: 1
      },
      940: {
        items: 1
      }
    },
  };
  panTypeOptions = [
    { label: 'Individual', value: 'Individual' }
    // { label: 'Company (including Partnership, Trust, Society, School, Hospital etc.)', value: 'Company' }
  ];
  
  showEmailError: boolean = false;
  isSubmitted: boolean = false;
  constructor(private regexService: RegexService, private spinner: NgxSpinnerService, private formErrorService: FormErrorService,
    private activatedRoute: ActivatedRoute, private apiService: ApiService,
    private storageService:RootService,private behaviourSubject:BehaviourSubjectService,
    private toastrService: ToastrService,
    private localStorage :secureStorage, private formBuilder: FormBuilder,
    private CommonService: CommonService, private router: Router,
    private cleverService: ClevertapService,
    @Inject(PLATFORM_ID) private platformId: Object,) { }

  ngOnInit(): void {

      try {
        this.cleverService.onPageView('Login Page');
      } catch {}
    if (isPlatformBrowser(this.platformId)) {
    this.isTataOk = window.location.href.includes('buy-used-vehicles');
    this.resetFormGroup()
    this.behaviourSubject.loginNumber.subscribe(params => {
      this.mobileNo = JSON.parse(this.localStorage.getItem("loginNumber"));
    })
  }
    this.getBanners();
    this.getState();
    if (isPlatformBrowser(this.platformId)) {
    this.behaviourSubject.loginNumber.subscribe((value) => {
      this.loginId = JSON.parse(this.localStorage.getItem('loginNumber'));
    });
    setTimeout(() => {
      this.setBannerList();
    }, 2000);
  }
  }
  resetFormGroup() {
    this.signupFormGroup = this.formBuilder.group({
      firstName: [
        this.signupFormGroup?.value?.firstName
          ? this.CommonService.replaceUnicode(
              this.signupFormGroup?.value?.firstName
            )
          : '',
        [Validators.required, Validators.pattern(/^[a-zA-Z\s]+$/)],
      ],
      lastName: [
        this.signupFormGroup?.value?.lastName
          ? this.CommonService.replaceUnicode(
              this.signupFormGroup?.value?.lastName
            )
          : '',
        [Validators.pattern(/^[a-zA-Z\s]+$/)],
      ],
      email_id: [''],
      // email_id: ["", [Validators.required,Validators.pattern(this.regexService.Email)]],
      occupation: [''],
      // email_and_whatsapp:["",[Validators.required]],
      // only_email:["",[Validators.required]]
      email_and_whatsapp: [''],
      only_email: [''],
      state: ['', Validators.required],
      district: ['', Validators.required],
      panType: ['', Validators.required],
      CompanyName: [''],
    });
    this.signupFormGroup.get('panType')?.valueChanges.subscribe((value) => {
      this.updateFirstNameValidation(value);
    });
  }

  signup() {
    this.isSubmitted = true;
    if (this.showEmailError && this.email.length > 0) {
      this.formErrorService.displayFormErrors(this.signupFormGroup);
      return;
    }
    if (this.signupFormGroup.status == 'INVALID') {
      this.formErrorService.displayFormErrors(this.signupFormGroup);
      return;
    }

    let data = {
      first_name:
        this.signupFormGroup.value.panType === 'Individual'
          ? this.CommonService.replaceUnicode(
              this.signupFormGroup.value.firstName
            )
          : this.CommonService.replaceUnicode(
              this.signupFormGroup.value.CompanyName
            ),
      last_name:  this.signupFormGroup.value.panType === 'Individual'
        ? this.signupFormGroup?.value?.lastName ?  this.CommonService.replaceUnicode(
            this.signupFormGroup?.value?.lastName
          ) :'.'
        : '.',
      mobile_number: this.mobileNo,
      email_id: this.signupFormGroup.value.email_id,
      state: this.signupFormGroup.value.state,
      district: this.signupFormGroup.value.district,
      account_type: this.signupFormGroup.value.panType,
    };

    this.spinner.show();
    this.sub.add(this.apiService.userSignup(data).subscribe({
      next: (response: any) => {
        if (response.success) {
          setTimeout(() => {
            this.behaviourSubject.isTataOkLogin.next(true);
          }, 2000);
          
            try {
              this.cleverService.onUserSignup(response.data.first_name + ' ' + response.data.last_name, response.data.email_id, response.data.mobile_number);
              this.cleverService.onUserSignUpFunc(response.data.first_name, response.data.last_name, response.data.email_id, response.data.mobile_number);
            } catch { }
          

            //redirect flow
        if (isPlatformBrowser(this.platformId)) {
            if(!window.location.href.includes('buy-used-vehicles')){
              this.toastrService.success("Login Successfully")
            }
          this.storageService.loginUser(response.data);
          // this.storageService.loginUser(response.data);
          // this.sentOtp(response.data.mobile_number);
          var path = localStorage.getItem('previousUrl')
          ? localStorage.getItem('previousUrl')
          : 'home';
        
        if (path.includes('lead-booking?vc') || path.includes('lead-booking?dealer')) {
          if (
            localStorage.getItem('dealercd') ||
            localStorage.getItem('vc')
          ) {
            if (
              localStorage.getItem('dealercd') &&
              localStorage.getItem('vc')
            ) {
              this.router.navigate(['/lead-booking'], {
                queryParams: {
                  dealer: localStorage.getItem('dealercd'),
                  vc: localStorage.getItem('vc'),
                },
              });
            } else if (localStorage.getItem('dealercd')) {
              this.router.navigate(['/lead-booking'], {
                queryParams: {
                  dealer: localStorage.getItem('dealercd'),
                },
              });
            } else {
              this.router.navigate(['/lead-booking'], {
                queryParams: { vc: localStorage.getItem('vc') },
              });
            }
          }
        } else {

          this.router.navigate([path]);
        }
      }
        //redirect flow end
        this.spinner.hide()

        }
        else{
          this.toastrService.warning("Something went wrong!")
        this.spinner.hide();
        }

      },
      error: () => {
        this.toastrService.warning("Something went wrong!")
        this.spinner.hide();
      },
      complete: () => { }
    }))
  }

  sentOtp(mobileNo) {

    this.spinner.show();
    let data = {
      mobile_number: mobileNo,
      action_type: 'login',
    };
    this.sub.add(
      this.apiService.sentOtp1(data).subscribe({
        next: (response: any) => {
          if (response.success) {
            if (isPlatformBrowser(this.platformId)) {
              this.toastrService.success(response.data.msg);
              this.spinner.hide();
              this.localStorage.setItem(
                'loginNumber',
                JSON.stringify(this.mobileNo)
              );
              this.localStorage.setItem(
                'signup',
                JSON.stringify(this.mobileNo)
              );
              // this.router.navigate(['/otp/']);
              this.goToLogin();
              if (isPlatformBrowser(this.platformId)) {
              window.scroll(0, 0);
              }
            } else {
              this.spinner.hide();
              if (response?.data?.msg == 'User is not registered.') {
                if (isPlatformBrowser(this.platformId)) {
                this.localStorage.setItem(
                  'loginNumber',
                  JSON.stringify(this.mobileNo)
                );
              }
                // this.router.navigate(['/signup']);
                this.loadParent.emit();
              } else {
                this.toastrService.warning('Something went wrong!');
                this.spinner.hide();
              }
            }
          }
        },
        error: () => {
          this.toastrService.warning('Something went wrong!');
          this.spinner.hide();
        },
        complete: () => {},
      })
    );
  }

  onlyNumberKey(event: any) {
    return this.regexService.NumberKeyEvent(event);
  }

  backToLogin() {
    // this.router.navigate(['/login'])
    this.loadParent.emit();
  }
  getBanners() {
    this.CommonService.getBannerList();

  }

  setBannerList() {
    // this.centerBanners = this.banners;
    this.banners = this.CommonService.bannerList;
    if (this.banners?.length > 0) {
      this.isLoading = true;
      this.centerBanners = this.banners;
    }
  }

  GetTest(data: any) {
    let url;
    var dataUrl = data.banner_link;
    if (dataUrl) {
      url =
        dataUrl?.replace('https://', '') &&
        dataUrl?.replace(environment.baseUrl, '');
      this.router.navigateByUrl(url);
    }
  }

  public hasRequiredError = (controlName: string): boolean | undefined =>
    this.formErrorService.hasRequiredError(controlName, this.signupFormGroup);
  public hasPatternError = (controlName: string): boolean | undefined =>
    this.formErrorService.hasPatternError(controlName, this.signupFormGroup);
  public hasMinLengthError = (controlName: string): boolean | undefined =>
    this.formErrorService.hasPatternError(controlName, this.signupFormGroup);
  public hasInvalidEmailError = (controlName: string): boolean | undefined =>
    this.formErrorService.hasInvalidEmailError(this.signupFormGroup.value.email_id);

  onlyAlphabets(event: any) {
    return this.regexService.Alpha(event);
  }
  notAllowSpace(event: any) {
    if ((event.target.selectionStart === 0 && event.which === 32) || event.key === '.') {
      event.preventDefault();
    }
  }
  alphanumbericOnlyFirstLastName(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/[a-zA-Z]|[.]|[ ]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  emailValidator(event){
    this.showEmailError = false;
    this.email = event.target.value;
    var validRegex = '^.+@.+\\..+$';

    if (this.email.match(validRegex)) {
      this.showEmailError = false;
     }
    else{
      this.showEmailError = true;
    }
    if(this.email?.length==0){
      this.showEmailError = false;
    }
  }

  getState() {
    let data = {
      // lob: this.lob
    }
    this.sub.add(this.apiService.getStateList(data).subscribe({
        next: (res: any) => {
          this.stateList = res;
          // this.getDistrictList();
      }
    }))
  }

  getDistrictList(item?) {
    this.signupFormGroup.controls['district'].setValue('');
    this.signupFormGroup.get('district').updateValueAndValidity();

    this.districtList = [];
    let statecode;
    let state = this.signupFormGroup.value.state;
    // this.profileFormGroup.value.state;
    this.stateList?.forEach((e: any) => {
      if (e.name == state) {
        statecode = e.code;
      }
    });

    let dummyList = {};
    dummyList = {
      code: statecode,
      state: state,
    };

    let stateData = {
      state: dummyList,
    };

    this.sub.add(this.apiService.getDistrictList(stateData).subscribe({
        next: (response: any) => {
          this.districtList = response;

        },
      error: (error) => {
      },
      complete: () => {
      }
      })
    );
  }
  nAllowSpace(event: KeyboardEvent) {
    if (event.key === ' ') {
      event.preventDefault();
    }
  }
  ngOnDestroy(): void {
    this.sub.unsubscribe()
  }

  goToLogin(){
      this.loadOtpParent.emit();
  }
  get f(): { [key: string]: AbstractControl } {
    return this.signupFormGroup.controls;
  }

 
  updateFirstNameValidation(accountType: string) {
    const firstNameControl = this.signupFormGroup.get('firstName');
    const CompanyNameControl = this.signupFormGroup.get('CompanyName');

    if (accountType === 'Individual') {
      firstNameControl?.setValidators([
        Validators.required,
        this.individualNameValidator,
      ]);
      CompanyNameControl?.setValidators([]);
    } else if (
      accountType === 'Company'
    ) {
      firstNameControl?.setValidators([]);
      CompanyNameControl?.setValidators([
        Validators.required,
        this.companyNameValidator,
      ]);
    }

    firstNameControl?.updateValueAndValidity();
    CompanyNameControl?.updateValueAndValidity();
  }

  // Validator for Individual Names (Only Alphabets and Spaces)
  individualNameValidator(control: AbstractControl) {
    const nameRegex = /^[A-Za-z\s]+$/; // Only letters and spaces
    if (control.value && !nameRegex.test(control.value)) {
      return { invalidIndividualName: true };
    }
    return null;
  }

  nameErrors: { [key: string]: boolean } = {
    firstName: false,
    lastName: false,
  };

  validateName(event: any, fieldName: string) {
    let inputValue = event.target.value;
    const regex = /^[a-zA-Z\s]*$/;
    if (!regex.test(inputValue)) {
      this.nameErrors[fieldName] = true;
    } else {
      this.nameErrors[fieldName] = false;
    }
    inputValue = inputValue.replace(/[^a-zA-Z\s]/g, '');
    event.target.value = inputValue;
    this.signupFormGroup.controls[fieldName].setValue(inputValue, {
      emitEvent: false,
    });
  }

  checkNameError(fieldName: string) {
    const fieldValue = this.signupFormGroup.controls[fieldName].value;
    this.nameErrors[fieldName] = /[^a-zA-Z\s]/.test(fieldValue);
  }

  removeSpecialChars(event: any) {
    let inputValue = event.target.value;

    inputValue = inputValue.replace(/[^a-zA-Z\s]/g, '');

    event.target.value = inputValue;

    this.signupFormGroup.controls['firstName'].setValue(inputValue, {
      emitEvent: false,
    });
  }

  companyNameError: boolean = false;

validateCompanyName(event: any) {
  let inputValue = event.target.value;
  const restrictedChars = /[<>{}|~^*]/;

  if (restrictedChars.test(inputValue)) {
    this.companyNameError = true;
  } else {
    this.companyNameError = false;
  }

  inputValue = inputValue.replace(/[<>{}|~^*]/g, '');
  event.target.value = inputValue;

  this.signupFormGroup.controls['CompanyName'].setValue(inputValue, { emitEvent: false });
}

checkCompanyNameError() {
  const fieldValue = this.signupFormGroup.controls['CompanyName'].value;
  this.companyNameError = /[<>{}|~^*]/.test(fieldValue);
}


  // Validator for Company Names (Allow all except < > { } | ~ ^ *)
  companyNameValidator(control: AbstractControl) {
    const restrictedChars = /[<>{}|~^*]/; // Restricted special characters
    if (control.value && restrictedChars.test(control.value)) {
      return { invalidCompanyName: true };
    }
    return null;
  }
  hasError(controlName: string, errorType: string) {
    return this.signupFormGroup.get(controlName)?.hasError(errorType); //&& this.signupFormGroup.get(controlName)?.touched;
  }
}